export const stylePrejoin = {
    // A full-width row of its own above the participant count / join row: as a
    // third item inside that row it stole width from the join button.
    // The moderator-only join options sit in one bordered group above the join
    // row: they change what the join does, so they belong before the button, and
    // one frame around both reads as a single set rather than two loose cards.
    moderatorOptions: {
        background: '#F4F8FD',
        border: '1px solid #E4EBF5',
        borderRadius: '8px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        margin: '4px 0 12px',
        overflow: 'hidden',
        textAlign: 'left',
        width: '100%'
    },
    moderatorOption: {
        alignItems: 'center',
        boxSizing: 'border-box',
        color: '#131519',
        cursor: 'pointer',
        display: 'flex',
        gap: '10px',
        margin: 0,
        padding: '6px 12px',
        textAlign: 'left',
        width: '100%'
    },

    // Second row onwards: a hairline instead of a gap, so the group stays one
    // block instead of turning back into stacked cards.
    moderatorOptionDivided: {
        alignItems: 'center',
        borderTop: '1px solid #E4EBF5',
        boxSizing: 'border-box',
        color: '#131519',
        cursor: 'pointer',
        display: 'flex',
        gap: '10px',
        margin: 0,
        padding: '6px 12px',
        textAlign: 'left',
        width: '100%'
    },
    backstageOption: {
        alignItems: 'flex-start',
        background: '#F4F8FD',
        border: '1px solid #E4EBF5',
        borderRadius: '8px',
        boxSizing: 'border-box',
        color: '#131519',
        cursor: 'pointer',
        display: 'flex',
        gap: '10px',
        margin: '16px 0 0',
        padding: '10px 12px',
        textAlign: 'left',
        width: '100%'
    },
    backstageCheckbox: {
        accentColor: '#4B6790',
        cursor: 'pointer',
        flexShrink: 0,
        height: '16px',
        marginTop: '2px',
        width: '16px'
    },
    backstageTextCol: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1px',
        minWidth: 0
    },
    backstageTitle: {
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '16px'
    },
    backstageHint: {
        color: '#5E6D7A',
        fontSize: '11px',
        lineHeight: '13px'
    },
    readyjoin: {
        fontSize: '1.2rem',
        color: '#000',
        textAlign: 'start',
        marginTop: '10px',
        fontWeight: 'bold'
    },
    maxParticipantStyle: {
        fontSize: '1rem',
        color: '#000',
        marginTop: '10px',
        fontWeight: 'bold',
        textAlign: 'center'

    },
    readySpan: {
        backgroundColor: '#4e6372',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '20px',
        display: 'inline-flex'
    },
    readySpan1: {
        backgroundColor: '#F8FBFF',
        color: '#000',
        padding: '8px 16px',
        borderRadius: '10px',
        display: 'inline-flex',
        width: 'max-content',
        border: '1px solid #c7d5e9',
        gap: '5px'
    },
    readyIconSpan: {
        marginTop: '2px',
        paddingLeft: '2px',
        color: 'black',
        fontSize: 'small'
    },
    paneToggleRow: {
        display: 'flex',
        justifyContent: 'center',
        margin: '6px 0 4px',
        width: '100%'
    },
    paneBadge: {
        backgroundColor: '#D51616',
        borderRadius: '9px',
        color: '#FFFFFF',
        fontSize: '11px',
        lineHeight: '18px',
        minWidth: '18px',
        padding: '0 5px',
        textAlign: 'center'
    },
    readyForm: {
        width: '90%',
        margin: 'auto',
        marginTop: '15px',
        marginBottom: '30px'
    },
    readyh4: {
        fontSize: '1.5rem',
        color: '#000',
        marginBottom: '5px'
    },
    readyStrong: {
        fontSize: '12px',
        color: '#000'
    },
    alignCenter: {
        width: '80%',
        maxWidth: '800px',
        borderRadius: '10px',
        margin: 'auto',
        backgroundColor: '#f6f6f6',
        color: '#000',
        padding: '20px',
        marginTop: '51px'
    },
    loadingImg: { width: '80px' },
    h4Style: {
        marginTop: '10px',
        color: '#000',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '1.5rem',
        fontWeight: '500',
        lineHeight: '1.2'
    },
    iconStyle: {
        margin: 'none'
    },
    margin20: {},
    inputBoxName: {
        border: '1px solid #b5cbeb',
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '50%',
        padding: '5px',
        height: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputBoxEmail: {
        border: '1px solid #b5cbeb',
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '100%',
        padding: '5px',
        height: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
